export default __webpack_public_path__ + "static/media/plaque2.171e55fc.jpg";